import { useQueryCache } from '@pinia/colada'
import { patchActiveExecutionInCache } from '~/lib/orders/activeExecutionsCache'

export default defineNuxtPlugin(() => {
    const { start, onBusinessOrderExecution } = useSseEvents()
    const queryCache = useQueryCache()

    start()
    onBusinessOrderExecution((execution) => {
        patchActiveExecutionInCache(queryCache, execution)
    })
})
